//various parameters defining the size and style of things


//a css used widely, to center text and stimuli
export const textStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "left",
    minHeight: "100vh",
    marginLeft: "20vw",
    marginRight: "20vw",
    fontSize: "20px",
}

//the css for buttons
export const buttonStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto",
    fontSize: "24px",
    cursor: 'pointer',
};